export const TEXT = {
    HEADING: "We ship Internationally",
    COUNTRIES_SUPPORTED:
        "We ship to US, UK, Canada, UAE, Malaysia, South Africa, Oman, Australia, Mauritius, Qatar, Singapore, Hong Kong, Afghanistan, South Africa",
    MORE_INFO_LINK: "Get more details.",
    LISTING_HEADER: "A few things to know:",
    SHIPPING_INFO: [
        "You can change the price and payment currency to the currency of your choice.",
        "International shipping cost outside India is free for order for INR 21,000 or more. Orders under INR 7,000 (~ USD 100) are charged INR 700 (~ USD 10); orders under INR 21,000 (~ USD 300) are charged INR 1400 (~ USD 20).",
        "Customs will be charged before delivery bases on actual customs charged by your country of delivery address.",
    ],
    LABELS: {
        SHOPTO: "Ship To",
        SHOPIN: "Shop In",
    },
    BUTTONS: {
        SAVE: "Save",
    },
    QUESTIONS_GUIDE: "Questions about international shipping?",
};
